import axios from 'axios';

import { API_TOKEN, SESSION_ID } from 'utils/globals';

function getCSRFToken() {
  const csrfField = document.querySelector('meta[name="csrf-token"]');
  return csrfField ? csrfField.getAttribute('content') : '';
}

const wosAPIHeaders = {
  'X-CSRF-Token': getCSRFToken(),
  'Content-Type': 'application/json',
  Authorization: `Token token="${API_TOKEN}"`,
  session_id: SESSION_ID,
};

export default axios.create({ baseURL: '', headers: wosAPIHeaders });

export const eventsAPI = axios.create({
  baseURL: '/meta_tracking_events',
  headers: wosAPIHeaders,
});
